// extracted by mini-css-extract-plugin
export var active = "header-module--active--9fdf4";
export var brandContainer = "header-module--brand-container--75248";
export var globalHeader = "header-module--global-header--2c31d";
export var globalNavigation = "header-module--global-navigation--b9528";
export var headerContainer = "header-module--header-container--3ff0d";
export var linkButton = "header-module--link-button--0e9c5";
export var logo = "header-module--logo--716bb";
export var menuButton = "header-module--menu-button--aee4e";
export var menuPanel = "header-module--menu-panel--cd570";
export var tagline = "header-module--tagline--0bd1a";